import axios from "axios";
import { REACT_APP_API } from "../environment";
import {getTokenFromStorage, getAwsTokenFromStorage} from "./users.service"

const token = getTokenFromStorage();
const aws_token = getAwsTokenFromStorage();

let headers = {
  "Content-Type": "application/json",
  "Authorization": token,
};

export const getParentServices = () => {
  return axios.get(`${REACT_APP_API}/getServiceEntity`, { headers: headers });
}

export const getReleaseDetails = (id, service) => {
  headers['id'] = id;
  headers['service'] = service;
  return axios.get(`${REACT_APP_API}/release_details`, { headers: headers });
}

export const getReleaseDetailsById = (releaseId) => {
  return axios.get(`${REACT_APP_API}/release_details`, {
    headers: headers,
    params: { id: releaseId }
  });
};

export const getAwsReleaseDetailsById = (releaseId, email) => {
  headers["event_id"] = releaseId;
  headers["email_id"] = email;
  headers["aws_token"] = aws_token;
  return axios.get(`${REACT_APP_API}/aws/release_details`, {
    headers: headers,
  });
};


export const getServiceId=(service)=>{
  headers['service']=service;
  return axios.get(`${REACT_APP_API}/service_id`,{headers:headers});
};

export const getSourceLastUpdatedTime = () => {
  return axios.get(`${REACT_APP_API}/lastupdated`, { headers: headers });
}

export const getActiveSources = () => {
  return axios.get(`${REACT_APP_API}/activeSources`, { headers: headers });
}

export const getAwsDescriptionbyTitle = (releaseTitle) => {
  headers["release_title"] = releaseTitle
  return axios.get(`${REACT_APP_API}/releaseDescription`, { headers: headers });
}

export const shareRelease = (body) => {
  return axios.post(`${REACT_APP_API}/share_release`, body, { headers: headers });
}

export const getServiceAliases = (body) => {
  return axios.post(`${REACT_APP_API}/serviceAliases`, body, { headers: headers });
}

export const getServiceMapping = (body) => {
  return axios.post(`${REACT_APP_API}/serviceMapping`, body, { headers: headers });
}

export const getServiceComponents = (body) => {
  return axios.post(`${REACT_APP_API}/serviceComponents`, body, { headers: headers });
}

export const getDependentServices = (body) => {
  return axios.post(`${REACT_APP_API}/dependentServices`, body, { headers: headers });
}

export const getReleaseBasedOnJobs = (body) => {
  return axios.post(`${REACT_APP_API}/jobBasedReleases`, body, { headers: headers });
}

export const getReleaseBasedServiceComponents = (body) => {
  return axios.post(`${REACT_APP_API}/serviceComponentReleases`, body, { headers: headers });
}

export const getReleaseBasedDependentServices = (body) => {
  return axios.post(`${REACT_APP_API}/dependentServicesReleases`, body, { headers: headers });
}

export const toggleUpvote = (body) => {
  return axios.post(`${REACT_APP_API}/toggle_upvote`, body, { headers: headers });
}

export const getSubscribedReleases = (body) => {
  return axios.post(`${REACT_APP_API}/subscribed_releases`, body, { headers: headers });
}

export const searchReleases = (searchText, searchType,pastRelease) => {
  return axios.get(`${REACT_APP_API}/search_releases`, {
    headers: headers,
    params: {
      text: searchText,
      type: searchType,
      filter:pastRelease
    },
  });
};
